import React, { useState } from 'react';
import Header from '../ui/Header';
import Sidebar from '../ui/Sidebar';
import Breadcrumb from '../ui/Breadcrumb';
import Icon from '../AppIcon';

const PageLayout = ({
  title,
  subtitle,
  iconName,
  headerRight = null,
  children,
}) => {
  const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleSidebarToggle = () => setSidebarCollapsed(!isSidebarCollapsed);
  const handleMobileMenuToggle = () => setMobileMenuOpen(!isMobileMenuOpen);
  const handleMobileMenuClose = () => setMobileMenuOpen(false);

  return (
    <div className="min-h-screen bg-background app-gradient">
      <Header onMenuToggle={handleMobileMenuToggle} isMobileMenuOpen={isMobileMenuOpen} />
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        onToggle={handleSidebarToggle}
        isMobileOpen={isMobileMenuOpen}
        onMobileClose={handleMobileMenuClose}
      />
      <main
        className={`
          pt-16 transition-all duration-300 ease-in-out
          lg:pt-16 sm:pt-14
          ${isSidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'}
        `}
      >
        <div className="p-6 lg:p-8 sm:p-4">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb />

            {(title || subtitle) && (
              <div className="mb-8">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-5">
                    {iconName && (
                      <div className="w-14 h-14 bg-gradient-to-br from-primary via-primary to-secondary rounded-2xl flex items-center justify-center shadow-2xl">
                        <Icon name={iconName} size={40} variant="masked" className="text-white" />
                      </div>
                    )}
                    <div>
                      {title && (
                        <h1 className="text-4xl font-bold text-foreground lg:text-4xl sm:text-3xl mb-2">{title}</h1>
                      )}
                      {subtitle && (
                        <p className="text-muted-foreground lg:text-lg sm:text-base">{subtitle}</p>
                      )}
                    </div>
                  </div>
                  {headerRight}
                </div>
              </div>
            )}

            {children}
          </div>
        </div>
      </main>
    </div>
  );
};

export default PageLayout;